
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 53 53","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M20.105 34.725a14.63 14.63 0 110-29.22 14.49 14.49 0 018.48 2.71l-1.46 2a12 12 0 00-7-2.24 12.11 12.11 0 1011.38 7.86l2.34-.88a14.64 14.64 0 01-13.74 19.77z"}}),_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M30.425 13.745a11.84 11.84 0 00-1.49-2l1.82-1.71a14.14 14.14 0 011.8 2.34z"}}),_c('path',{staticClass:"icon-fill arrow",attrs:{"fill":"#5ebca8","d":"M26.975 14.515l1.76 1.77-9.66 9.66-6.51-6.51 1.77-1.76 4.74 4.74z"}}),_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M20.105 39.695a19.6 19.6 0 1119.59-19.59 19.62 19.62 0 01-19.59 19.59zm0-36.69a17.1 17.1 0 1017.09 17.1 17.12 17.12 0 00-17.09-17.1zM46.895 52.505l-11.6-11.6 5.65-5.65 11.56 11.64zm-8.06-11.6l8.06 8.06 2.11-2.11-8.06-8.06z"}}),_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M34.28 36.044l1.768-1.767 3.846 3.847-1.768 1.768z"}})])
          )
        }
      }
    